/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function OrganicIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 0 20 20"
      {...rest}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path d="M7.053 5.875c1.308 0 2.38 1.287 2.459 2.906l.004.188V10H7.463c-1.31 0-2.381-1.284-2.459-2.905L5 6.906V5.875h2.053zM15 4v1.463c0 1.82-1.262 3.306-2.853 3.407l-.172.005h-1.728a4.33 4.33 0 00-.209-1.335l-.257.06c1.534-.324 2.903-1.124 4.108-2.4-1.755.925-3.173 1.413-4.255 1.465a3.662 3.662 0 00-.44-.59c.439-1.158 1.429-1.989 2.596-2.069L11.975 4H15z"></path>
        <path d="M6.586 13.201l-1.015-.927a.872.872 0 00-1.15-.026l1.07 2.041-.518.28-1.21-2.227V8.765C3.763 7.78 2.97 6.986 2 7v5.616l2.35 4.497v1.49h2.94v-1.49l.16-1.793c.005-.063.009-.127.01-.19a2.715 2.715 0 00-.874-1.929zM12.874 13.201l1.016-.927a.872.872 0 011.15-.026l-1.07 2.041.518.28 1.21-2.227V8.765c0-.985.793-1.779 1.763-1.765v5.616l-2.351 4.497v1.49h-2.938v-1.49l-.161-1.793a3.041 3.041 0 01-.011-.19 2.715 2.715 0 01.874-1.929z"></path>
      </g>
    </svg>
  );
}
